/* eslint-disable */
import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import moment from "moment";
import { isMobile, isTablet } from "react-device-detect";

function AllocationDetails() {
  const [list, setpricinglist] = useState([]);
  const [tradinglist, settradinglist] = useState([]);
  const [query, setquery] = useState("");
  const [queryTrading, setquerytrading] = useState("");
  const [timeStampAllocate, setTimeStampAllocate] = useState("");
  const [timeStampTrading, setimeStampTrading] = useState("");

  const instrumentsToGroup = {
    "1A": "1A Goulburn",
    "1B": "1A Goulburn",
    3: "1A Goulburn",
    "4A": "1A Goulburn",
    "5A": "1A Goulburn",
    6: "6 Murray",
    "6B": "7 Murray",
    7: "7 Murray",
    "7GMW": "7 Murray",
    "7LMW": "7 Murray",
    10: "10 Murray",
    "10MIL": "10 Murray",
    11: "11 Murray",
    "11WMI": "11 Murray",
    12: "12 SA",
    "12CIT": "12 SA",
    "12RIT": "12 SA",
    13: "13M'bidgee",
    "13CICL": "13M'bidgee",
    "13MIA": "13M'bidgee",
  };

  const handleToggle = (e) => {
    const itemListElm = e.target.closest(
      ".plm-item-detail-wrapper"
    ).nextSibling;

    if (itemListElm) {
      if (itemListElm.style.display === "none") {
        itemListElm.style.display = "block";
        e.target.innerHTML = "-";
      } else {
        itemListElm.style.display = "none";
        e.target.innerHTML = "+";
      }
    }
  };

  Array.prototype.peek = function () {
    if (this.length > 0) {
      return this[this.length - 1];
    }
    // empty array...
    return undefined; // or another default value...
  };

  function searchAllocation(rows) {
    return rows.filter((row) => {
      return (
        row.instrument.toString().toLowerCase().indexOf(query.toLowerCase()) >
        -1
      );
    });
  }

  function searchTrading(rows) {
    return rows.filter((row) => {
      return (
        row.instrument
          .toString()
          .toLowerCase()
          .indexOf(queryTrading.toLowerCase()) > -1
      );
    });
  }

  useEffect(() => {
    fetchAPI();
  }, []);

  useEffect(() => {
    let hash = window.location.hash.substr(1);
    let hashElement = document.getElementById(hash);
    if (hashElement) {
      hashElement.scrollIntoView({ behavior: "smooth" });
    }
  }, [list]);

  function getGroup(instrument) {
    let group = instrumentsToGroup[instrument];
    if (group == null || group.length < 1) {
      group = instrument;
    }
    return group;
  }

  // Parse YYYY-MM-DDTHH:mm:ss as UTC
  function parseUTC(s) {
    var b = s.split(/\D/);
    return new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5]));
  }

  async function fetchAPI() {
    const requestPricingAPI = "/wp-json/xpansiv/v1/pricingData/";
    const requestTradeAPI = "/wp-json/xpansiv/v1/tradingData/";

    let pricingResponse = await fetch(requestPricingAPI);
    let pricingJson = await pricingResponse.json();

    const pricingData = pricingJson.result.data;

    for (let i = 0; i < pricingData.length; i++) {
      pricingData[i].instrument = pricingData[i].instrument.replace(
        "11WMI",
        "11"
      );
      pricingData[i].instrument = pricingData[i].instrument.replace(
        "7GMW",
        "7"
      );
    }

    for (let i = 0; i < pricingJson.rows.length; i++) {
      pricingJson.rows[i].instrument = pricingJson.rows[i].instrument.replace(
        "11WMI",
        "11"
      );
      pricingJson.rows[i].instrument = pricingJson.rows[i].instrument.replace(
        "7GMW",
        "7"
      );
    }

    let timeStampAllocate = pricingJson.result.update_timestamp.toString();

    let utcTimeZonePricing = timeStampAllocate.replace("T", " ") + " UTC";
    let convertedPricingToLocalTime = new Date(utcTimeZonePricing);

    if (parseUTC(timeStampAllocate) !== "Invalid Date") {
      let d = parseUTC(timeStampAllocate);
      setTimeStampAllocate(d.toString());
    } else if (isNaN(Date.parse(convertedPricingToLocalTime))) {
      let localTimeZone = moment.utc(timeStampAllocate).toDate();

      if (localTimeZone || localTimeZone !== "Invalid Date") {
        setTimeStampAllocate(localTimeZone.toString());
      } else {
        let AEDTTimeZone = timeStampAllocate + "+11:00";
        let convertedAEDTTimeZone =
          moment().utcOffset(AEDTTimeZone).format("YYYY-MM-DD HH:mm:ss") +
          " (AEDT Time Zone)";

        setTimeStampAllocate(convertedAEDTTimeZone);
      }
    }

    // const sortedPricingData = pricingData.sort(function(a,b) {
    //     return a.instrument > b.instrument;
    // });

    let rows = pricingJson.rows;

    setpricinglist(rows);
    //document.getElementById('pending_pricing').style.display = "none";

    let tradeResponse = await fetch(requestTradeAPI);
    let tradeJson = await tradeResponse.json();

    let timeStampTrade = tradeJson.update_timestamp.toString();
    let utcTimeZoneTrading = timeStampTrade.replace("T", " ") + " UTC";
    let convertedTradingToLocalTime = new Date(utcTimeZoneTrading);

    if (parseUTC(timeStampTrade) !== "Invalid Date") {
      let d = parseUTC(timeStampTrade);
      setimeStampTrading(d.toString());
    } else if (isNaN(Date.parse(convertedTradingToLocalTime))) {
      let localTimeZone = moment.utc(timeStampTrade).toDate();

      if (localTimeZone || localTimeZone !== "Invalid Date") {
        setimeStampTrading(localTimeZone.toString());
      } else {
        let AEDTTimeZoneTrading = timeStampTrade + "+11:00";
        let convertedAEDTTimeZoneTrading =
          moment()
            .utcOffset(AEDTTimeZoneTrading)
            .format("YYYY-MM-DD HH:mm:ss") + " (AEDT Time Zone)";

        setimeStampTrading(convertedAEDTTimeZoneTrading);
      }
    }

    const tradingData = tradeJson.data;
    for (let i = 0; i < tradingData.length; i++) {
      tradingData[i].instrument = tradingData[i].instrument.replace(
        "11WMI",
        "11"
      );
      tradingData[i].instrument = tradingData[i].instrument.replace(
        "7GMW",
        "7"
      );
    }

    let sortedTradingData = tradingData.sort(function (a, b) {
      return new Date(a.timestamp).getTime() < new Date(b.timestamp).getTime();
    });
    settradinglist(sortedTradingData);
  }

  function pricingDesktopTable() {
    return (
      <div className="table table-light pb-4" style={{ marginTop: 20 + "px" }}>
        <div className="table--columns">
          <div scope="col">Market</div>
          <div scope="col">Buy Volume</div>
          <div scope="col">Buy Price</div>
          <div scope="col">Sell Volume</div>
          <div scope="col">Sell Price</div>
        </div>
        {list.length > 0 &&
          searchAllocation(list).map((item, id) => {
            return (
              <div className="table--row" key={uuidv4()}>
                <div>
                  <a id={item.group.replace(" ", "")}></a>
                  {item.instrument}
                </div>
                <div>{item.buyQuantity}</div>
                <div className="text-bid">
                  {item.buyPrice == null ? "" : "$" + item.buyPrice}
                </div>
                <div>{item.sellQuantity}</div>
                <div className="text-danger">
                  {item.sellPrice == null ? "" : "$" + item.sellPrice}
                </div>
              </div>
            );
          })}
      </div>
    );
  }

  function pricingMobileTable() {
    return (
      <div className="product-list-main">
        <div className="plm-item-title">
          <label className="font-weight-bold">Market</label>
        </div>

        {list.lengdiv > 1 &&
          searchAllocation(list).map((item, id) => {
            return (
              <div className="plm-item-wrapper" key={uuidv4()}>
                {id === 0 ? (
                  <div>
                    <div className="plm-item-detail-wrapper">
                      <div className="plm-item-detail-name">
                        <a id={item.instrument}></a>
                        {item.instrument}
                      </div>
                      <div
                        className="plm-item-detail-name font-weight-bold"
                        onClick={(e) => handleToggle(e)}
                      >
                        -
                      </div>
                    </div>
                    <div className="plm-item-detail-outer-wrapper">
                      <div className="plm-item-detail-wrapper">
                        <div className="plm-item-detail-name font-weight-bold">
                          Buy Volume
                        </div>
                        <div className="plm-item-detail-name font-weight-bold">
                          {item.buyQuantity}
                        </div>
                      </div>
                      <div className="plm-item-detail-wrapper">
                        <div className="plm-item-detail-name font-weight-bold">
                          Buy Price
                        </div>
                        <div className="plm-item-detail-name text-bid font-weight-bold">
                          {item.buyPrice == null ? "" : "$" + item.buyPrice}
                        </div>
                      </div>
                      <div className="plm-item-detail-wrapper">
                        <div className="plm-item-detail-name font-weight-bold">
                          Sell Volume
                        </div>
                        <div className="plm-item-detail-name font-weight-bold">
                          {item.sellQuantity}
                        </div>
                      </div>
                      <div className="plm-item-detail-wrapper">
                        <div className="plm-item-detail-name font-weight-bold">
                          Sell Price
                        </div>
                        <div className="plm-item-detail-name text-bid font-weight-bold">
                          {item.sellPrice == null ? "" : "$" + item.sellPrice}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div>
                    <div className="plm-item-detail-wrapper">
                      <div className="plm-item-detail-name">
                        <a id={item.instrument}></a>
                        {item.instrument}
                      </div>
                      <div
                        className="plm-item-detail-name font-weight-bold"
                        onClick={(e) => handleToggle(e)}
                      >
                        +
                      </div>
                    </div>
                    <div
                      className="plm-item-detail-outer-wrapper"
                      style={{ display: "none" }}
                    >
                      <div className="plm-item-detail-wrapper">
                        <div className="plm-item-detail-name font-weight-bold">
                          Buy Volume
                        </div>
                        <div className="plm-item-detail-name font-weight-bold">
                          {item.buyQuantity}
                        </div>
                      </div>
                      <div className="plm-item-detail-wrapper">
                        <div className="plm-item-detail-name font-weight-bold">
                          Buy Price
                        </div>
                        <div className="plm-item-detail-name text-bid font-weight-bold">
                          {item.buyPrice == null ? "" : "$" + item.buyPrice}
                        </div>
                      </div>
                      <div className="plm-item-detail-wrapper">
                        <div className="plm-item-detail-name font-weight-bold">
                          Sell Volume
                        </div>
                        <div className="plm-item-detail-name font-weight-bold">
                          {item.sellQuantity}
                        </div>
                      </div>
                      <div className="plm-item-detail-wrapper">
                        <div className="plm-item-detail-name font-weight-bold">
                          Sell Price
                        </div>
                        <div className="plm-item-detail-name text-bid font-weight-bold">
                          {item.sellPrice == null ? "" : "$" + item.sellPrice}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
      </div>
    );
  }

  function tradingDesktopTable() {
    return (
      <div className="table table-light pb-4" style={{ marginTop: 20 + "px" }}>
        <div className="table--columns">
          <div scope="col">Date/Time</div>
          <div scope="col">Market</div>
          <div scope="col">Volume</div>
          <div scope="col">Price</div>
        </div>
        {tradinglist.length > 0 &&
          searchTrading(tradinglist).map((item, id) => {
            const options = {
              month: "long",
              day: "numeric",
              year: "numeric",
              hour: "numeric",
              minute: "numeric",
            };
            console.log(item.timestamp);

            try {
              var timestamp = Intl.DateTimeFormat("en-AU", options).format(
                new Date(item.timestamp + "+0000")
              );
            } catch (e) {
              if (e instanceof RangeError) {
                var timestamp = "Recent";
              }
            }
            return (
              <div className="table--row" key={uuidv4()}>
                <div>{timestamp}</div>
                <div>
                  <a id={item.instrument}></a>
                  {item.instrument}
                </div>
                <div>{item.quantity}</div>
                <div className="text-bid">{"$" + item.price}</div>
              </div>
            );
          })}
      </div>
    );
  }

  function tradingMobileTable() {
    const options = {
      month: "long",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
    };
    return (
      <div className="product-list-main">
        <div className="plm-item-title">
          <label className="font-weight-bold">Date/Time</label>
        </div>

        {tradinglist.length > 1 &&
          searchTrading(tradinglist)
            .slice(1)
            .map((item, id) => {
              return (
                <div className="plm-item-wrapper" key={uuidv4()}>
                  {id === 0 ? (
                    <div>
                      <div className="plm-item-detail-wrapper">
                        <div className="plm-item-detail-name">
                          {new Intl.DateTimeFormat("en-AU", options).format(
                            new Date(item.timestamp + "+0000")
                          )}
                        </div>
                        <div
                          className="plm-item-detail-name font-weight-bold"
                          onClick={(e) => handleToggle(e)}
                        >
                          -
                        </div>
                      </div>
                      <div className="plm-item-detail-outer-wrapper">
                        <div className="plm-item-detail-wrapper">
                          <div className="plm-item-detail-name font-weight-bold">
                            Market
                          </div>
                          <div className="plm-item-detail-name font-weight-bold">
                            {item.instrument}
                          </div>
                        </div>
                        <div className="plm-item-detail-wrapper">
                          <div className="plm-item-detail-name font-weight-bold">
                            Volume
                          </div>
                          <div className="plm-item-detail-name font-weight-bold">
                            {item.quantity}
                          </div>
                        </div>
                        <div className="plm-item-detail-wrapper">
                          <div className="plm-item-detail-name font-weight-bold">
                            Price
                          </div>
                          <div className="plm-item-detail-name text-bid font-weight-bold">
                            {"$" + item.price}
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div>
                      <div className="plm-item-detail-wrapper">
                        <div className="plm-item-detail-name">
                          {new Intl.DateTimeFormat("en-AU", options).format(
                            new Date(item.timestamp + "+0000")
                          )}
                        </div>
                        <div
                          className="plm-item-detail-name font-weight-bold"
                          onClick={(e) => handleToggle(e)}
                        >
                          +
                        </div>
                      </div>
                      <div
                        className="plm-item-detail-outer-wrapper"
                        style={{ display: "none" }}
                      >
                        <div className="plm-item-detail-wrapper">
                          <div className="plm-item-detail-name font-weight-bold">
                            Market
                          </div>
                          <div className="plm-item-detail-name font-weight-bold">
                            {item.instrument}
                          </div>
                        </div>
                        <div className="plm-item-detail-wrapper">
                          <div className="plm-item-detail-name font-weight-bold">
                            Volume
                          </div>
                          <div className="plm-item-detail-name font-weight-bold">
                            {item.quantity}
                          </div>
                        </div>
                        <div className="plm-item-detail-wrapper">
                          <div className="plm-item-detail-name font-weight-bold">
                            Price
                          </div>
                          <div className="plm-item-detail-name text-bid font-weight-bold">
                            {"$" + item.price}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
      </div>
    );
  }

  return (
    <div className="xsv-trading">
      <div className="row xsv-trading-item">
        <div className="col-12 col-sm-7">
          <p className="headline_copy" style={{ color: "white" }}>
            Allocation Bids &amp; Offers
          </p>
          <p className="allocation-detail-dislaimer section_header">
            All volumes are specified in megalitres. Prices shown below
            exclusive of Water Authority fees and H2OX Exchange fees.
          </p>
        </div>
        <div className="col-12 col-sm-5">
          <input
            placeholder="Filter Allocation Markets"
            className="__xsv_filter-product-detail-search"
            value={query}
            onChange={(e) => {
              setquery(e.target.value);
            }}
          />
        </div>
      </div>

      {isMobile && !isTablet ? pricingMobileTable() : pricingDesktopTable()}
      <span id="pending_pricing" className="allocation-detail-dislaimer">
        Last updated {timeStampAllocate}
      </span>

      <div className="row xsv-trading-item">
        <div className="col-12 col-sm-7">
          <p className="headline_copy" style={{ color: "white" }}>
            Recent Allocation Trades
          </p>
          <p className="allocation-detail-dislaimer section_header">
            All volumes are specified in megalitres. Prices shown below
            exclusive of Water Authority fees and H2OX Exchange fees.
          </p>
        </div>
        <div className="col-12 col-sm-5">
          <input
            placeholder="Filter Trading Markets"
            className="__xsv_filter-product-detail-search"
            value={queryTrading}
            onChange={(e) => {
              setquerytrading(e.target.value);
            }}
          />
        </div>
      </div>
      {isMobile && !isTablet ? tradingMobileTable() : tradingDesktopTable()}
      <span id="pending_trading" className="allocation-detail-dislaimer">
        Last updated {timeStampTrading}
      </span>
    </div>
  );
}

export default AllocationDetails;
/* eslint-enable */



// WEBPACK FOOTER //
// ./scripts/components/AllocationDetails.js